export default "__VITE_ASSET__BCGxOjxn__"